<template>
     <layout>
        <div class="d-flex justify-center mt-4">
            <v-card width="350" class="pa-3 mr-4 d-flex" flat outlined rounded="lg">
                <span class="mr-6">
                    <DatePicker 
                        label="Start Date"
                        :selected-date="attendanceDates[0]"
                        @date-selected="setAttendanceStartDate"   
                        :initial-allowed-dates="allowedDates"             
                    ></DatePicker>        
                </span>
            
                <span>
                    <DatePicker 
                        label="End Date"
                        :selectedDate="attendanceDates[1]"
                        @date-selected="setAttendanceEndDate" 
                        :initial-allowed-dates="allowedDates"                 
                    ></DatePicker>        
                </span>
            </v-card>
        </div>
        <v-row 
            align="center"
            justify="center"
        >
         <v-card
            class="mt-3 pa-3"
            width="600"
            flat
            outlined
        >
            <v-data-table
                :headers="headers"
                :items="records"
                :loading="loading"  
                height="50vh"
                fixed-header
                class="custom-table"
            >
                <template v-slot:item="{ item }">
                    <tr>
                        <td class="px-0"><div class="card">{{ item.date_scanned }}</div></td>
                        <td class="px-0"><div class="card">{{ item.time_scanned }}</div></td>
                        <td class="px-0"><div class="card">{{ item.time_out }}</div></td>
                        <td class="px-0"><div class="card">{{ item.am_session }}</div></td>
                        <td class="px-0"><div class="card">{{ item.pm_session }}</div></td>
                        <td class="px-0"><div class="card">{{ item.minutes_late }}</div></td>
                    </tr>
                </template>
            </v-data-table>
        </v-card>  
        </v-row>
    </layout>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import Layout from './layouts/App';
import DatePicker from './DatePicker';
export default {
    name: 'Attendance',
    components: {
        Layout,
        DatePicker
    },

    created(){
        this.initialize();
    },

    data: function(){
        return {
            records: [],
            headers:[
                { text: 'Date', value: 'date_scanned', sortable: false },
                { text: 'Time In', value: 'time_scanned', sortable: false },
                { text: 'Time Out', value: 'time_out', sortable: false },
                { text: 'AM Session', value: 'am_session', sortable: false },
                { text: 'PM Session', value: 'pm_session', sortable: false },
                { text: 'Minutes Late', value: 'minutes_late', sortable: false },
            ],
            loading: false,
            attendanceDates: [],
            labelStartDate: 'Start Date',
            labelEndDate: 'End Date',
            allowedDates: [],
        }

    },

    methods:{
        ...mapActions({
            getAttendanceData: 'attendance/getAttendanceData',
            getValidAttendanceDates: 'attendance/getValidAttendanceDates',
        }),

        ...mapMutations({
            setAttendanceDates: 'attendance/setAttendanceDates',
        }),

        async initialize(){
            console.log('initializing...');
            this.getCurrentWeekRange();
            this.getAttendanceRecords();
            try {
                const { data } = await this.getValidAttendanceDates();  
                this.allowedDates = data;
            } catch (error) {
                error.response ? console.log(error.response) : error
            }
        },

        getCurrentWeekRange(){
            const today = new Date();
            const day = today.getDay();
            const monday = new Date(today);
            monday.setDate(today.getDate() - day + (day === 0 ? -6 : 1));
            const friday = new Date(monday);
            friday.setDate(monday.getDate() + 4);
            this.attendanceDates = [this.formatDate(monday), this.formatDate(friday)];
        },

        formatDate(date){
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`
        },

        setAttendanceStartDate(date){
            this.attendanceDates[0] = date;
            if(this.attendanceDates.length == 2) this.getAttendanceRecords();
        },

        setAttendanceEndDate(date){
            this.attendanceDates[1] = date;
            if(this.attendanceDates.length == 2) this.getAttendanceRecords();
        },

        async getAttendanceRecords(){
            console.log('fetching data...');
            this.loading = true;
            this.setAttendanceDates(this.attendanceDates);
            try{
                const { data } = await this.getAttendanceData();
                this.records = data;
            } catch (error){
                console.log(error);
            } finally {
                this.loading = false;
            }
        }
    }
}
</script>

<style scoped>
    ::v-deep .v-data-table-header {
        background: rgb(169, 168, 168);
    }

    ::v-deep .custom-table{
        border-collapse: separate;
        border-spacing: 0 14px;
    }

    ::v-deep .card{
        background: rgb(212, 245, 222);
        padding: 14px;
        margin-top: 12px;
        margin-bottom: 12px;
        height: 50px;
    }

    td:first-child .card {
        border-top-left-radius: 12px;
        border-bottom-left-radius: 12px;
    }

    td:last-child .card {
        border-top-right-radius: 12px;
        border-bottom-right-radius: 12px;
    }

    .v-data-table tbody tr:hover{
        background-color: transparent !important;
    }

    .v-data-table .v-data-table__wrapper table tbody tr td{
        border-bottom: none !important;
    }


</style>